<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><i>Contents</i></span></p>
<p class="toc-text"><a href="#/xhtml/chapter001"><span><i>The Cathedral</i></span></a></p>
<p class="toc-text"><a href="#/xhtml/chapter002"><span><i>Tenth Street</i></span></a></p>
<p class="toc-text"><span href="#/xhtml/chapter003" title="Link target outside of Sample"><span><i>The Hunter Portrait</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><span><i>Bishop Bodeway’s Past</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter005" title="Link target outside of Sample"><span><i>The Kommandant</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter006" title="Link target outside of Sample"><span><i>A Concert in Munich</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter007" title="Link target outside of Sample"><span><i>Elective Affinities</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter008" title="Link target outside of Sample"><span><i>The Wooden Madonna</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter009" title="Link target outside of Sample"><span><i>Parents and Children</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter010" title="Link target outside of Sample"><span><i>The Discipline of Memory</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter011" title="Link target outside of Sample"><span><i>A Change of Program</i></span></span></p>
<p class="toc-text"><span href="#/xhtml/chapter012" title="Link target outside of Sample"><span><i>Music in the Cathedral</i></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/bio" title="Link target outside of Sample"><i>A Biography of Madeleine L’Engle</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9d0954ca